import React from 'react';
import cn from 'classnames';
import {ButtonColour} from './ButtonColour';

type Props = {
  on: boolean
  active: boolean
  handleStateSwitch: (state: boolean) => void
  colour?: ButtonColour
}

export default function Toggle({on, active, handleStateSwitch, colour = ButtonColour.RED}: Props) {
  const handleClick = () => {
    if (active) {
      handleStateSwitch(!on);
    }
  };
  const red = colour === ButtonColour.RED;
  const blue = colour === ButtonColour.BLUE;
  const green = colour === ButtonColour.GREEN;

  return (
    <>
      <span role="checkbox" onClick={handleClick} tabIndex={0} aria-checked="false" data-testid="toggle"
            className={cn(
              {
                'bg-gray border-gray': !on,
                'bg-red border-red': on && red,
                'bg-blue border-blue': on && !red && !green,
                'bg-green border-green': on && green,
              }, {'bg-opacity-40 border-opacity-0': !active},
              ' relative inline-flex flex-shrink-0 h-6 w-10 border-2 border-transparent rounded-full ' +
              'cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none'
            )}>
        <span aria-hidden="true"
              className={cn(
                {'translate-x-0': !on, 'translate-x-5': on},
                'translate-y-0.5 inline-block h-4 w-4 rounded-full bg-white shadow transform ' +
                'transition ease-in-out duration-200'
              )}></span>
      </span>
    </>
  );
}
